import AboutData from './AboutData';
import HowToPurchaseData from './HowToPurchaseData';
import HowDoesItWork from './HowDoesItWorkData';
import WhoIsThisProductFor from './WhoIsThisProductData';
import HowIsItUsed from './HowIsItUsedData';

export default function TermData() {
  const minAge = 50;
  const maxAge = 85;
  const minCoverageAmount = 5000;
  const maxCoverageAmount = 250000;

  return {
    name: 'Disability Insurance',
    subtitle: '',
    specs: {
      age: { min: minAge, max: maxAge },
      coverageAmount: { min: minCoverageAmount, max: maxCoverageAmount },
    },
    hyperlinks: [
      {
        title: 'ABOUT',
        link: 'about'

      },
      {
        title: 'HOW IS IT USED',
        link: 'howIsItUsed',
      },
      {
        title: 'WHO IS THIS PRODUCT FOR',
        link: 'whoIsThisProductFor',
      },
      {
        title: 'HOW TO PURCHASE',
        link: 'howToPurchase',
      }
    ],
    about: AboutData(),
    howToPurchase: HowToPurchaseData(),
    howDoesItWorkData: HowDoesItWork(),
    WhoIsThisProductData: WhoIsThisProductFor(),
    HowIsItUsedData: HowIsItUsed()
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/data/products/disability-insurance/DisabilityInsuranceData.js